/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_imprint.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions Custom */
HafasWebapp.prototype.subscriptions.Imprint = function (_me) {
  Hafas.ps.sub('/imprint/index', Hafas.bind(_me.Controller.Imprint.index, _me));
  Hafas.ps.sub('/GUI/leaveContext/Imprint', Hafas.bind(_me.Controller.Imprint.closeView,_me));
  Hafas.ps.sub('/GUI/restoreView/Imprint', Hafas.bind(_me.Controller.Imprint.restoreView,_me));
};